/* eslint-disable */
import dayjs from 'dayjs';
import { DATE_FORMAT_FILTER_COLUMN } from 'utils/date';

dayjs.locale('es');
const construirFechaFromString = (fecha) => {
  if (fecha && fecha !== '') {
    return dayjs(fecha, 'YYYYMMDDHHmmss').format(DATE_FORMAT_FILTER_COLUMN);
  }
  return '';
};

const construirPeriodo = (id, inicio, fin) => {
  if (id !== 0 && inicio && fin) {
    return `${construirFechaFromString(inicio).substring(0, 19)} al ${construirFechaFromString(
      fin
    )}`;
  }
  return 'Otro';
};

export const filterList = (list, filters) => 
{
  const activeFilters = Object.keys(filters);
  const filteredData = list?.filter((row) => 
  {
    for (let i = 0; i < activeFilters.length; i += 1) 
    {
      const fieldName = activeFilters[i];
      if (typeof filters[fieldName] === 'object') 
      {
        if (filters[fieldName] != null && !filters[fieldName]?.isSame(row[fieldName], 'day'))
          return false;
      } else if (typeof filters[fieldName] === 'number') 
      {
        if (filters[fieldName] !== row[fieldName]) return false;
      } else if (
        fieldName === 'periodo' &&
        filters[fieldName] !== null &&
        filters[fieldName] !== ''
      ) {
        if (
          !construirPeriodo(
            row.hallazgos[0].idPeriodo,
            row.hallazgos[0].inicioPeriodo,
            row.hallazgos[0].finPeriodo
          ).includes(filters[fieldName])
        )
          return false;
      } else if (
        fieldName === 'numEmpleado' &&
        filters[fieldName] !== null &&
        filters[fieldName] !== ''
      ) {
        const rowValue = row[fieldName]?.toString();
        if (rowValue === undefined || (rowValue && !rowValue.includes(filters[fieldName]))) {
          return false;
        }
      } else 
      {
        const filterValue = filters[fieldName]?.toUpperCase();
        const rowValue = row[fieldName]?.toUpperCase();
        if (filterValue && rowValue && !rowValue.includes(filterValue)) return false;
      }
    }
    return list;
  });
  return filteredData || [];
};
